<script>
export let is_active;


</script>


<style>

</style>



<div class="modal" class:is-active={is_active}>

	<div class="modal-background"></div>

	<div class="modal-content">

		<!-- modal-card-head -->
		<p class="image" style="border: 6px solid white; border-radius: 5px;">
			<img src="/img/tracksuit_size_chart.png">
		</p>

	</div>

	<button class="modal-close is-large" aria-label="close" on:click={() => is_active = false}></button>

</div>

